import React from "react";
import moment from "moment";
import "moment/locale/fr";
import useEnhancedIntl from "../../hooks/useEnhancedIntl";

function MomentLocaleSetup() {
  const { locale } = useEnhancedIntl();

  React.useEffect(() => {
    switch (locale) {
      case "en-US":
        moment.locale("en");
        break;
      case "fr-FR":
        moment.locale("fr");
        break;
      default:
        moment.locale("en");
    }
  }, [locale]);

  return null;
}

export default MomentLocaleSetup;
